import { BrowserRouter, Route, Routes  } from 'react-router-dom';
import Login from "./pages/Login"
import CheckUser from "./pages/CheckUser"
import Home from "./pages/Home"
import AuthRoute from './components/AuthRoute';
import User from './pages/User';
import UpdateUserPassword from './pages/UpdateUserPassword';
import ResetPassword from './pages/ResetPassword';
import ForgetPassword from './pages/ForgotPassword';
import RequestAccount from './pages/RequestAccount';
import CaseManagement from './pages/CaseManagement';
import CaseCreation from './pages/CaseCreation';
// import CaseCreationWizard from './pages/CaseCreationWizard';
import InterviewWizard from './pages/InterviewWizard';
import MasterDataManagement from './components/MasterDataManagement';
import ScoringMethod from './pages/ScoringMethod';
import References from './pages/References';
import ChatbotSettings from './pages/ChatbotSettings';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import SubscriptionManagement from './pages/SubscriptionManagement';
import SupportPage from './pages/SupportPage';

function Router() {
  return (
  <BrowserRouter>
      <Routes>
      
      <Route path="/Login"  element={<Login/>}/>
      <Route path="/check-user"  element={<CheckUser/>}/>
      <Route path="/create-password"  element={<UpdateUserPassword/>}/>
      <Route path="/forgotpassword" element={<ForgetPassword/>}/>
      <Route path="/resetpassword" element={<ResetPassword/>}/>
      <Route path="/signup" element={<RequestAccount/>}/>
      <Route path="/payment-success" element={<PaymentSuccess/>}/>
      <Route path="/payment-failed" element={<PaymentFailed/>}/>

      <Route path="/" element={<AuthRoute><Home/></AuthRoute>}/>
      <Route path="/users" element={<AuthRoute allowedRoles={['admin']}><User/></AuthRoute>}/>
      <Route path="/cases" element={<AuthRoute allowedRoles={['admin']}><CaseManagement/></AuthRoute>}/>
      <Route path="/create-case" element={<AuthRoute requireSubscription={true}><CaseCreation/></AuthRoute>}/>
      <Route path="/create-case-wizard" element={<AuthRoute requireSubscription={true}><InterviewWizard/></AuthRoute>}/>
      <Route path="/master-data" element={<AuthRoute allowedRoles={['admin']}><MasterDataManagement/></AuthRoute>}/>
      <Route path="/scoring-method" element={<AuthRoute allowedRoles={['admin']}><ScoringMethod/></AuthRoute>}/>
      <Route path="/references" element={<AuthRoute allowedRoles={['admin']}><References/></AuthRoute>}/>
      <Route path="/chatbot-settings" element={<AuthRoute allowedRoles={['admin']}><ChatbotSettings/></AuthRoute>}/>
      <Route path="/settings/billing" element={<AuthRoute><SubscriptionManagement/></AuthRoute>}/>
      <Route path="/support" element={<AuthRoute disallowedRoles={['admin']}><SupportPage/></AuthRoute>}/>
      <Route path="/help-support" element={<AuthRoute disallowedRoles={['admin']}><SupportPage/></AuthRoute>}/>
    
      </Routes>
  </BrowserRouter>
  )
}
export default Router